/* eslint-disable max-lines */
/* eslint-disable sort-keys */
/* eslint-disable max-depth */
/* eslint-disable max-statements */
import React, { createContext, useContext, useMemo, useState } from 'react'
import { postReativarAssinaturaAPI } from '../api/reativacao.servico'
import { useGlobal } from './GlobalContext'
import { isEmptyObject, objetoTemPropriedade } from '../utils/helpers/helpers'
import {
  METODO_PAGAMENTO_CARTAO,
  METODO_PAGAMENTO_PIX,
  PLANO_ANUAL,
  ROUTE_BASEPATH
} from '../constants'
import {
  ETAPA_BRINDES,
  ETAPA_CONCLUSAO,
  ETAPA_ENTREGA,
  ETAPA_PAGAMENTO,
  ETAPA_PLANO
} from '../components/FluxosPagamento/constantsFluxosPagamento'
import {
  BASES_OBRIGATORIAS_REATIVACAO,
  BASES_OPCIONAIS_REATIVACAO,
  BASE_PROPRIEDADE_ASSINATURA_REATIVACAO,
  BASE_PROPRIEDADE_BRINDE_REATIVACAO,
  BASE_PROPRIEDADE_CUPONS_REATIVACAO,
  BASE_PROPRIEDADE_ENTREGA_REATIVACAO,
  BASE_PROPRIEDADE_PAGAMENTO_REATIVACAO,
  BASE_PROPRIEDADE_PLANO_REATIVACAO,
  BASE_PROPRIEDADE_PAGAMENTO_CARTAO_REATIVACAO
} from '../containers/Modalidade/Plano/ReativacaoAssinatura/constantsReativacaoAssinatura'
import ErrorMessages from '../utils/adyen/ErrorMessages'
import { navigate } from '@reach/router'
import { URLS_APP } from '../config'
import { reactivationEvent, userDataEvent } from '../utils/events/events'
import { rdReactivationEvent } from '../utils/events/eventsRdStation'
import { getDadosAssociado } from '../api/associado.servico'

const ReativacaoAssinaturaContext = createContext()

function ReativacaoAssinaturaProvider( props ) {
  const [ state, setState ] = useState( {
    'dadosRetornoRequisicao': null,
    'loadingReativacaoAssinatura': false,
    'sucessoReativacao': false,
    'tipoPagamentoReativacao': null
  } )

  const value = useMemo( () => {
    return {
      setState,
      state
    }
  }, [ state ] )

  return (
    <ReativacaoAssinaturaContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function useReativacaoAssinatura() {
  const context = useContext( ReativacaoAssinaturaContext )
  if ( !context ) {
    throw new Error( 'useReativacaoAssinatura deve ser usado dentro de um ReativacaoAssinaturaProvider' )
  }

  const { state, setState } = context
  const { setErroRequisicao, modalidadeURL } = useGlobal()

  const setSucessoReativacao = sucesso => {
    setState( prevState => ( {
      ...prevState,
      'sucessoReativacao': sucesso
    } ) )
  }

  const setTipoPagamentoRenovacao = pagamento => {
    setState( prevState => ( {
      ...prevState,
      'tipoPagamentoReativacao': pagamento
    } ) )
  }

  const setLoadingReativacaoAssinatura = loading => {
    setState( prevState => ( {
      ...prevState,
      'loadingReativacaoAssinatura': loading
    } ) )
  }

  const setDadosRetornoRequisicao = dados => {
    setState( prevState => ( {
      ...prevState,
      'dadosRetornoRequisicao': dados
    } ) )
  }

  const postReativarAssinatura = async(
    assinatura,
    dadosReativar,
    setEtapaAtiva = null,
  ) => {
    let objetoFinal
    let isPagamentoCartao
    let isPagamentoPix
    setLoadingReativacaoAssinatura( true )
    Object.entries( dadosReativar ).forEach( reativacao => {
      const [ chave, objeto ] = reativacao
      if ( !isEmptyObject( objeto ) ) {
        if ( chave === ETAPA_PLANO ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_PLANO_REATIVACAO ]: {
              'id': dadosReativar[ chave ].id ? dadosReativar[ chave ].id : null
            }
          }
        }

        if ( chave === ETAPA_BRINDES ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_BRINDE_REATIVACAO ]: objeto.id
          }
        }

        if ( chave === ETAPA_ENTREGA ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_ENTREGA_REATIVACAO ]: {
              'id': dadosReativar[ chave ].id
                ? Number( dadosReativar[ chave ].id )
                : null
            }
          }
        }

        if ( chave === ETAPA_PAGAMENTO ) {
          const hasParcelaCartaoCredito = objetoTemPropriedade(
            dadosReativar[ chave ],
            'parcela'
          )
            ? dadosReativar[ chave ].parcela
            : 0
          const hasPromocao =
            objetoTemPropriedade( dadosReativar[ chave ], 'promocao' ) &&
            !isEmptyObject( dadosReativar[ chave ].promocao )
              ? dadosReativar[ chave ].promocao.codigo
              : null

          if ( dadosReativar[ chave ].metodoPagamento === METODO_PAGAMENTO_CARTAO.slug ) {
            isPagamentoCartao = true
            isPagamentoPix = false
          } else if ( dadosReativar[ chave ].metodoPagamento === METODO_PAGAMENTO_PIX.slug ) {
            isPagamentoCartao = false
            isPagamentoPix = true
          }

          if ( hasPromocao ) {
            objetoFinal = {
              ...objetoFinal,
              [ BASE_PROPRIEDADE_CUPONS_REATIVACAO ]: [ hasPromocao ]
            }
          }

          const getIdBackendMetodoPagamento = () => {
            if ( isPagamentoCartao ) {
              return Number( dadosReativar[ chave ].id )
            } else if ( isPagamentoPix ) {
              return METODO_PAGAMENTO_PIX.idBackend
            }
          }

          const getTipoMetodoPagamento = () => {
            if ( isPagamentoCartao ) {
              return METODO_PAGAMENTO_CARTAO.slugBackend
            } else if ( isPagamentoPix ) {
              return METODO_PAGAMENTO_PIX.slugBackend
            }
          }

          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_PAGAMENTO_REATIVACAO ]: {
              [ BASE_PROPRIEDADE_PAGAMENTO_CARTAO_REATIVACAO ]: {
                'cvv': isPagamentoCartao
                  ? dadosReativar[ ETAPA_CONCLUSAO ].confirmacaoCVV
                  : '',
                'id': getIdBackendMetodoPagamento()
              },
              'parcelas': isPagamentoCartao
                ? hasParcelaCartaoCredito
                : PLANO_ANUAL.parcelas,
              'tipo': getTipoMetodoPagamento()
            }
          }
        }

        if ( !isEmptyObject( assinatura ) ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_ASSINATURA_REATIVACAO ]: assinatura.id
          }
        }
      }
    } )

    const podeFazerReativacao = Object.keys( objetoFinal ).every( chave => BASES_OBRIGATORIAS_REATIVACAO.includes( chave ) ||
        BASES_OPCIONAIS_REATIVACAO.includes( chave ) )

    if ( podeFazerReativacao ) {
      try {
        const { 'data': dados } = await postReativarAssinaturaAPI( objetoFinal )
        if ( !isEmptyObject( dados ) ) {
          setSucessoReativacao( true )
          setDadosRetornoRequisicao( dados.assinatura )
          setLoadingReativacaoAssinatura( false )
          const dadosAssociado = ( await getDadosAssociado() ).data

          userDataEvent( {
            'email': dadosAssociado.email,
            'phone': dadosAssociado.telefone,
            'name': `${dadosAssociado.nome} ${dadosAssociado.sobrenome}`,
            'userId': dadosAssociado.id,
            'productPrice': dados.assinatura.vendas[ 0 ].pagamento.valor.kit,
            'freightPrice': dados.assinatura.vendas[ 0 ].pagamento.valor.frete,
            'totalDiscount': dados.assinatura.vendas[ 0 ].pagamento.desconto.total,
            'paymentHash': dados.assinatura.vendas[ 0 ].pagamento.cobrancas[ 0 ].hash,
            'promotionCoupon': objetoFinal[ BASE_PROPRIEDADE_CUPONS_REATIVACAO ] ? objetoFinal[ BASE_PROPRIEDADE_CUPONS_REATIVACAO ][ 0 ] : null,
            'planId': objetoFinal.plano.id,
          } )
          reactivationEvent( {
            'paymentMethod': objetoFinal.pagamento.tipo,
            'productPrice': dados.assinatura.vendas[ 0 ].pagamento.valor.kit,
            'freightPrice': dados.assinatura.vendas[ 0 ].pagamento.valor.frete,
            'totalDiscount': dados.assinatura.vendas[ 0 ].pagamento.desconto.total,
            'paymentHash': dados.assinatura.vendas[ 0 ].pagamento.cobrancas[ 0 ].hash,
            'promotionCoupon': objetoFinal[ BASE_PROPRIEDADE_CUPONS_REATIVACAO ] ? objetoFinal[ BASE_PROPRIEDADE_CUPONS_REATIVACAO ][ 0 ] : null,
            'planId': objetoFinal.plano.id,
          } )
          rdReactivationEvent( {
            'planId': objetoFinal.plano.id,
            'email': dadosAssociado.email,
          } )
        }
      } catch ( erros ) {
        setSucessoReativacao( false )
        setLoadingReativacaoAssinatura( false )

        if ( erros?.response ) {
          let message = null
          if ( erros?.response?.data?.errors ) {
            message = erros?.response?.data?.errors[ 0 ]?.message
          } else {
            message = erros?.response?.data[ 0 ]
          }

          if ( ErrorMessages.includes( message ) ) {
            const descricaoErro = {
              'descricao': message,
              'titulo': 'Houve um erro no pagamento!'
            }
            setErroRequisicao( 400, descricaoErro )
            if ( message !== 'CVV inválido.' && setEtapaAtiva ) {
              setEtapaAtiva( 2 )
              navigate( `${ROUTE_BASEPATH}${
                URLS_APP.BASE_PATH ? '/' : ''
              }${modalidadeURL}/plano/reativar-assinatura/selecionar-pagamento` )
            }
          } else {
            const descricaoErro = {
              'descricao': message,
              'titulo': 'Erro inesperado!'
            }
            setErroRequisicao( 400, descricaoErro )
          }
        } else {
          const descricaoErro = {
            'descricao': 'Por favor, atualize a página e refaça o processo. Se persistir, contate o suporte.',
            'titulo': 'Erro inesperado!'
          }
          setErroRequisicao( 400, descricaoErro )
        }
      }
    }
  }

  return {
    'dadosRetornoRequisicao': state.dadosRetornoRequisicao,
    'loadingReativacaoAssinatura': state.loadingReativacaoAssinatura,
    postReativarAssinatura,
    setTipoPagamentoRenovacao,
    'sucessoReativacao': state.sucessoReativacao,
    'tipoPagamentoReativacao': state.tipoPagamentoReativacao,
    setLoadingReativacaoAssinatura
  }
}

export { ReativacaoAssinaturaProvider, useReativacaoAssinatura }
